import * as React from "react";
import {Cookies, withCookies} from "react-cookie";

import "./maintenance.scss";

import {MaintenanceConfiguration} from "../../config/maintenance-configuration";
import {Icon} from "../icon/icon";
import {instanceOf} from "prop-types";
import {IAppStore, withStore} from "../../stores/abstract-app-store";

export interface MaintenanceProps {
    config: MaintenanceConfiguration[];
    cookies: Cookies;
    store?: IAppStore; // this is injected by withStore
}

class Maintenance extends React.Component<MaintenanceProps, any> {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    state = { visible: true};
    messageId;
    dismiss: string[] = [];
    maintenanceUiRef = React.createRef<HTMLDivElement>();

    constructor(props: MaintenanceProps) {
        super(props);
        const { cookies, config } = this.props;
        const cookieString = cookies.get("m-dismiss");
        this.messageId = ""+Math.min(...config.map((m) => m.from.getTime()))
            +"-"+Math.max(...config.map((m) => m.to.getTime()));
        this.dismiss = cookieString? cookieString.split(";"): [];
        this.state = {
            visible: !this.dismiss.includes(this.messageId)
        };
        this.handleDismiss = this.handleDismiss.bind(this);
    }
    handleDismiss = () => {
        const { cookies, store } = this.props;
        this.setState({ visible: false });
        store?.uiStore.setUiOffsetTop();
        this.dismiss.push(this.messageId);
        cookies.set("m-dismiss", this.dismiss.join(";"), { path: "/", sameSite: "lax" });
    };
    componentDidMount(): void {
        const {store} = this.props;
        store?.uiStore.setUiOffsetTop(this.maintenanceUiRef.current?.clientHeight);
    }
    render(): JSX.Element | null {
        if (!this.state.visible) {
            return null;
        }
        const now = new Date();
        const maintenance = this.props.config.filter((m: MaintenanceConfiguration) =>
            // only display message in configured time frame
            now > m.from && now < m.to
        );

        const message: JSX.Element[] = [];
        maintenance.forEach((m: MaintenanceConfiguration, index) => {
            message.push(<p key={index} dangerouslySetInnerHTML={{__html: m.message as string}}/>);
        });

        if (message.length === 0) {
            return null;
        }
        return(
            <div className="maintenance" ref={this.maintenanceUiRef}>
                {message}
                <Icon onClick={this.handleDismiss} name="navigate_cross"
                    title={"Hinweis schliessen"} />
            </div>
        );
    }
}
export default withCookies(withStore(Maintenance));
